import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logos/footer/RP_ADEME.jpg")